import { render, staticRenderFns } from "./CheckService.vue?vue&type=template&id=efba67d2&"
import script from "./CheckService.vue?vue&type=script&lang=js&"
export * from "./CheckService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports